export const chevronRight16 = "M5.793 12l4-4-4-4h1.414l4 4-4 4z";
